import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { VendorApiService } from '../../../services/api/vendor-api.service';
import { IVendor } from '../../../types/api-response/building/vendor';
import { take } from 'rxjs/operators';
import { IVendorCategory } from '../../../types/api-response/building/vendor-category';
import { forkJoin } from 'rxjs/observable/forkJoin';

interface SelectItem {
    name: string;
    id: number;
    type?: ItemType;
    sponsored?: boolean;
}

enum ItemType {
    vendor = 'Vendors',
    category = 'Vendor Categories'
}

@Component({
    selector: 'vendor-select',
    templateUrl: './vendor-select.component.html',
    styleUrls: ['./vendor-select.component.scss']
})
export class VendorSelectComponent implements OnInit {

    isVendorsLoading = false;
    isCategoryVendorsLoading = false;

    selectedVendorValue: SelectItem = null;
    selectedCategory: SelectItem = null;

    selectItems: SelectItem[] = [];
    selectVendorItems: SelectItem[] = [];

    private vendors: IVendor[] = [];

    @Output() vendorChanged: EventEmitter<IVendor> = new EventEmitter<IVendor>();

    constructor(
        private vendorApi: VendorApiService
    ) {
    }

    ngOnInit() {
        this.loadVendorsAndCategories();
    }

    /*** BOF Getters and Setters ***/

    get selectedVendorOrCategory(): SelectItem {
        return this.selectedCategory || this.selectedVendor;
    }

    set selectedVendorOrCategory(value: SelectItem) {
        if(!value) {
            this.selectedCategory = null;
            this.selectedVendor = null;

            return;
        }

        if(value.type === ItemType.category) {
            this.selectedCategory = value;
            this.selectedVendor = null;
            this.setCategoryVendorValues(value.id);
        } else {
            this.selectedVendor = value;
        }
    }

    get selectedVendor(): SelectItem {
        return this.selectedVendorValue;
    }

    set selectedVendor(value: SelectItem) {
        if(value !== this.selectedVendorValue) {
            const vendor = value ? this.vendors.find(item => +item.id === value.id) : null;
            this.vendorChanged.emit(vendor);
        }

        this.selectedVendorValue = value;
    }

    /*** EOF Getters and Setters ***/

    /**
     * Init Vendors and Vendor Categories data loading
     */
    private loadVendorsAndCategories() {
        this.isVendorsLoading = true;
        forkJoin(
            this.vendorApi.getVendorsShort({'per-page': 10000}),
            this.vendorApi.getVendorCategories({'per-page': 10000})
        ).pipe(
            take(1)
        ).subscribe(
            ([vendors, categories]) => {
                this.setSelectValues(vendors.entities, categories.entities);
                this.vendors = vendors.entities;
            },
            null,
            () => this.isVendorsLoading = false);
    }

    /**
     * Set select values
     *
     * @param vendors
     * @param categories
     */
    private setSelectValues(vendors: IVendor[], categories: IVendorCategory[]) {
        this.selectItems = [].concat(
            vendors.map(({id, name, sponsored}) => ({id, name, sponsored, type: ItemType.vendor})),
            categories.map(({id, name}) => ({id, name, type: ItemType.category}))
        );
    }

    /**
     * Set Category Vendor values
     * @param categoryId
     */
    private setCategoryVendorValues(categoryId) {
        this.isCategoryVendorsLoading = true;
        this.selectVendorItems = [];
        this.vendorApi.getVendorsShort({category_id: categoryId, 'per-page': 10000}).pipe(
            take(1)
        ).subscribe(
            result => this.selectVendorItems = result.entities.map(({id, name, sponsored}) => ({id, name, sponsored})),
            null,
            () => this.isCategoryVendorsLoading = false
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/service-request/vendor-select/vendor-select.component.ts